export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const SHOW_USER_SETTINGS_FORM_FOR_EDIT = 'SHOW_USER_SETTINGS_FORM_FOR_EDIT';
export const SHOW_USER_SETTINGS_FORM_FOR_ADD = 'SHOW_USER_SETTINGS_FORM_FOR_ADD';
export const HIDE_USER_SETTINGS_FORM_FOR_EDIT = 'HIDE_USER_SETTINGS_FORM_FOR_EDIT';
export const HIDE_USER_SETTINGS_FORM_FOR_ADD = 'HIDE_USER_SETTINGS_FORM_FOR_ADD';
export const FETCH_INITIAL_DATA_FOR_USER_SETTINGS = 'FETCH_INITIAL_DATA_FOR_USER_SETTINGS';
export const FETCH_INITIAL_DATA_FOR_USER_SETTINGS_SUCCESS = 'FETCH_INITIAL_DATA_FOR_USER_SETTINGS_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM = 'FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM';
export const FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_SUCCESS = 'FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_FAILURE = 'FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_FAILURE';
export const FETCH_LOGGED_IN_USER_SETTINGS_SUCCESS = 'FETCH_LOGGED_IN_USER_SETTINGS_SUCCESS';
export const FETCH_LOGGED_IN_USER_SETTINGS_FAILURE = 'FETCH_LOGGED_IN_USER_SETTINGS_FAILURE';
export const RESET_USER_TO_EDIT = 'RESET_USER_TO_EDIT';
export const SAVING_USER_SETTINGS = 'SAVING_USER_SETTINGS';
export const SAVING_USER_SETTINGS_SUCCESS = 'SAVING_USER_SETTINGS_SUCCESS';
export const SAVING_USER_SETTINGS_FAILURE = 'SAVING_USER_SETTINGS_FAILURE';
export const DISABLE_READ_ONLY_MODE = 'DISABLE_READ_ONLY_MODE';
export const CHECK_IF_USER_EMAIL_EXISTS = 'CHECK_IF_USER_EMAIL_EXISTS';
export const CHECK_IF_USER_EMAIL_EXISTS_SUCCESS = 'CHECK_IF_USER_EMAIL_EXISTS_SUCCESS';
export const CHECK_IF_USER_EMAIL_EXISTS_FAILURE = 'CHECK_IF_USER_EMAIL_EXISTS_FAILURE';
export const CHECK_IF_USER_PWC_EMAIL_SETUP = 'CHECK_IF_USER_PWC_EMAIL_SETUP';
export const CHECK_IF_USER_PWC_EMAIL_SETUP_SUCCESS = 'CHECK_IF_USER_PWC_EMAIL_SETUP_SUCCESS';
export const CHECK_IF_USER_PWC_EMAIL_SETUP_FAILURE = 'CHECK_IF_USER_PWC_EMAIL_SETUP_FAILURE';
export const CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN = 'CHECK_IF_USER_EMAIL_UNDER_DOMAIN';
export const CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_SUCCESS = 'CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_SUCCESS';
export const CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_FAILURE = 'CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_FAILURE';
export const CHECK_IF_USER_SSO_EXISTS = 'CHECK_IF_USER_SSO_EXISTS';
export const CHECK_IF_USER_SSO_EXISTS_SUCCESS = 'CHECK_IF_USER_SSO_EXISTS_SUCCESS';
export const CHECK_IF_USER_SSO_EXISTS_FAILURE = 'CHECK_IF_USER_SSO_EXISTS_FAILURE';

export const FETCH_ROLE_ASSIGNMENTS = 'FETCH_ROLE_ASSIGNMENTS';
export const FETCH_ROLE_ASSIGNMENTS_SUCCESS = 'FETCH_ROLE_ASSIGNMENTS_SUCCESS';
export const FETCH_ROLE_ASSIGNMENTS_FAILURE = 'FETCH_ROLE_ASSIGNMENTS_FAILURE';


export const SET_USER_MODIFIED = 'SET_USER_MODIFIED';

export const FETCH_EXPIRATION_DATE_PRIVILEGE = 'FETCH_USER_PRIVILEGES';
export const FETCH_EXPIRATION_DATE_PRIVILEGE_SUCCESS = 'FETCH_USER_PRIVILEGES_SUCCESS';
export const FETCH_EXPIRATION_DATE_PRIVILEGE_FAILURE = 'FETCH_USER_PRIVILEGES_FAILURE';
